import './Banner.scss';

import classnames from 'classnames';
import React from 'react';
import useAprExamples from '../../hooks/useAprExamples';
import { useSelector } from 'react-redux';

import AoIcon from '@aoworld-aotech/components-react/lib/Icon/Icon';

import { useIsBelowMediumOnly } from '../../hooks/mediaQueries';
import useCardView from '../../hooks/useCardView';
import { useTheme } from '../../hooks/useTheme';
import TRANSLATIONS from '../../translations/translations@default.json';
import { Switch24BannerTerms } from './Switch24BannerTerms';

const DesktopFinanceBanner = ({ index }) => {
	const {
		showSwitch24Example,
		financeRepExampleText,
		aprPurchaseRate,
		aprRepresentative,
	} = useAprExamples();

	const { isDealsPage } = useSelector((state) => state);

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const { isGridView } = useCardView();

	const theme = useTheme('financeBanner');

	const titleStyles = classnames(
		'flex-col text-title-sm leading-tight',
		theme.repExample.examples.title
	);

	const repTextStyles = classnames(
		'flex-col text-title leading-tight',
		theme.repExample.examples.title
	);

	const isBelowMediumOnly = useIsBelowMediumOnly();

	const gridSize = isGridView && (isDealsPage || isBelowMediumOnly) ? 4 : 3;

	if (gridSize !== index) {
		return null;
	}

	return (
		<li
			className={classnames(
				'flex w-full p-4 my-2 border border-solid border-gray-30 rounded-lg',
				theme.background,
				{
					'lg:mx-4 xl:mx-0': CustomCategoriesEnabled,
				}
			)}>
			<div className="flex flex-col flex-shrink-0 items-center justify-center w-1/4 mr-6 lg:flex-row">
				<AoIcon
					size="3x"
					icon="finance-gbp"
					className="text-cta-main mb-2 lg:mb-0 lg:mr-2"
				/>
				<div className="flex-col">
					<div className="flex-col text-title-sm lg:text-title-lg leading-tight text-primary">
						AO Finance
					</div>
					<div
						className={classnames(
							'text-left font-body leading-none mt-2 text-body-xs'
						)}>
						Pay your way
					</div>
				</div>
			</div>
			<div className="mr-4" style={{ borderRight: '1px solid #E2E7E8' }}></div>
			<div className="flex-col justify-around w-full">
				{showSwitch24Example && (
					<div
						className={`${titleStyles} mb-2`}
						data-testid="finance-rep-example-title">
						0% interest for 24 months with Switch24 on AO Finance. After that,
						interest applies to any remaining balance and to non-promotional
						purchases.
					</div>
				)}

				<div
					className={titleStyles}
					data-testid="finance-rep-example-sub-title">
					*AO Finance Representative Example
				</div>

				<div
					style={{ color: '#011F44' }}
					className={classnames(
						'font-body leading-tight mt-1 text-body-xs',
						theme.repExample.examples.description
					)}>
					Representative{' '}
					<span className={repTextStyles}>{aprRepresentative}% APR</span>{' '}
					(variable),{' '}
					<span className={repTextStyles}>{aprPurchaseRate}% PA</span> purchase
					rate (variable),{' '}
					<span className={repTextStyles}>
						{
							TRANSLATIONS.listerFooter.financeExample
								.assumedCreditLimitAmountText
						}
					</span>{' '}
					assumed credit limit.
				</div>
				<div
					style={{ fontSize: '10px' }}
					className={classnames(
						'font-body leading-snug mt-3 text-body-xs',
						theme.terms
					)}>
					18+, Credit and Offers are subject to status. Terms apply. NewDay Ltd,
					UK Only.
					<span className="font-bold">
						{' '}
						AO Retail Limited acts as a credit broker exclusively for NewDay Ltd
						and is not a lender.
					</span>
					{showSwitch24Example && (
						<>
							{' '}
							<span>
								{' '}
								AO membership annual fee of £39.99 payable to access exclusive
							</span>
							<span className="font-bold">
								{' '}
								Switch 24 offer on an AO Finance account.
							</span>
							<span>
								{' '}
								<a
									className="text-link"
									href="/help-and-advice/finance-and-savings/ao-five-star/t-and-cs">
									Membership terms
								</a>{' '}
								and{' '}
								<a className="text-link" href="/mobile-phones/switch24/tandcs">
									Switch24 terms
								</a>{' '}
								apply.
							</span>
						</>
					)}
				</div>
				<div
					style={{ fontSize: '10px' }}
					className={classnames(
						'font-body leading-snug mt-3 text-body-xs',
						theme.terms
					)}>
					<span>
						{TRANSLATIONS.listerFooter.financeExample.creditUpfrontText}
					</span>
				</div>
			</div>
		</li>
	);
};

export default DesktopFinanceBanner;
